import translate from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';
import api from '../../../../scripts/api';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class PgtsFactory {
    constructor({ options, currentMap }) {
        this.options = options;
    }

    getData() {
        const sizeCompaniesSource = environment.get('CONFIG.FILTERS.TRAFFIC_GENERATOR_POLE_COMPANY_SIZES');
 
        let data = [];

        if (isAuthorized(FeaturePermission.LAYER_GENERAL.pgtsFilterSizeCompany)) {
            data.push(
                {
                    name: 'pgtsSizeCompany',
                    position: 1,
                    data: sizeCompaniesSource,
                    fields: [
                        {
                            title: translate('Common.Port'),
                            name: 'sizeCompany',
                            value: 'id',
                            text: 'nome',
                            type: 'multiselect',
                        }
                    ]
                });
        }

        return data;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/pgts.factory.js